import { getConfig } from '~/org/twilio/one-support-center/shared/osc-env';

import {
  getTwilioHost,
  getTwilioProtocol,
  getRealm,
  types as envTypes,
} from '~/org/twilio/one-support-center/shared/osc-env';
import { postAuthRedirect } from '@twiliointernal/deeplink';

const { hostName } = getConfig();

export const twilioProtocol = getTwilioProtocol(
  window.location.hostname as envTypes.Hostname,
);
export const twilioHost = getTwilioHost(
  window.location.hostname as envTypes.Hostname,
);
export const twilioRealm =
  getRealm(window.location.hostname as envTypes.Hostname) || 'prod';

export const gitSha = process.env.NX_GIT_SHA;

export const signUpUrl = `${twilioProtocol}${twilioHost}/try-twilio`;

export const loginUrl = `${twilioProtocol}${twilioHost}/login`;

export const logoutUrl = `${twilioProtocol}${twilioHost}/logout`;

export const consoleUrl = `${twilioProtocol}${twilioHost.replace(
  /www/,
  'console',
)}`;

/**
 * Redirect the user to Help Center after login.
 *
 * @param path - Path to redirect to after login
 */
export const loginRedirectToOsc = async (path?: string): Promise<void> => {
  await postAuthRedirect({
    authLink: '/login',
    path,
    hostname: hostName,
  });
};
